// Current theme management - change import to change theme
import { theme as currentTheme } from './peakah';

export const theme = currentTheme;